const en = {
  mainTitle: 'Practical longevity protocol',
  habitTooltipTitle: 'Why do this?',
  foodScienceFactsTitle: 'Food-science facts that most influenced my choices',
  whatNotToEatTitle: 'What not to eat',
  whatToEatTitle: 'What to eat',
  damageIndexTitle: 'Damage Index',
  examplesTitle: 'Examples',
  genericRulesTitle: 'Generic rules',
  healthChoicesTitle: 'Food choices for Armenia',
  hacksTitle: 'Hacks',
  tooltipSubText: 'Consumption consequences',
  viewSleepChart: 'View sleep structure chart',
  viewSupplementsChart: 'View supplements structure chart',
  environmentHeadlines: {
    home: 'Home',
    principles: 'Principles',
    dataTracking: 'Data Tracking',
  },
  supplementsHeadlines: {
    foundational: 'Foundational',
    longevity: 'Longevity and Cellular Health',
    performance: 'Performance and Recovery',
    situational: 'Situational',
  },
  supplementsTableHeadlines: [
    'Area',
    'No supplements',
    'With supplements (Generic)',
    'Tailored Optimized (Bloodwork-driven)',
  ],
  whatTOEatOrAvoidContent: {
    damageIndexTxt: 'Damage index: ',
    yourDietTxt: 'Your diet',
  },
  yourDietContent: {
    brainPreservation: 'Brain preservation',
    yearsGained: 'Years of life gained!',
    biologicalAge: 'Biological Age:',
    skinAge: 'Skin Age:',
    jointAge: 'Joint Age:',
    metabolicAge: 'Metabolic Age:',
    yearSingular: 'year',
    yearFew: 'years',
    yearMany: 'years',
  },
  sleepTableTitles: [
    'Key Brain Rules',
    'no structure',
    'my structure',
    'fully optimized',
  ],
  sleepHeadlines: {
    keyBrainRules: 'Key brain rules',
    usedDevices: 'Used devices',
  },
  workoutHeadlines: {
    mandatoryWorkouts: 'Mandatory Workouts',
    optionalWorkouts: 'Optional workouts',
    workoutSupplements: 'Workout supplements',
  },
  totalWeeklyActivity: {
    title: 'Total weekly activity',
    minutes: 'minutes',
    min: 'min',
    years: 'Years',
    week: 'week',
    minAndSessions: 'Minutes / Session',
    sessionsAndWeek: 'Sessions / Week',
    earlyDyingRisk: 'Risk of Dying Early',
    brainAgeTitle: 'Brain age with different activity levels',
    brainAgeSubTitle: 'Select baseline age to see the difference',
    dementiaRisk: 'Estimated ↓ Cognitive Decline / Dementia Risk',
    agingTrajectory: 'Brain Aging Trajectory',
    brainIfSedentary: 'Brain age if sedentary',
    brainIfSedentarySubText: undefined,
    brainIfActive: 'Brain age if active',
    strengthTitle: 'Strength and Time Compression',
    strengthSubTitle: 'Your strength level',
    activityLevels: [
      {
        level: 'Novice',
        minutesPerSession: 65,
        totalMinutesPerWeek: 240,
      },
      {
        level: 'Base',
        minutesPerSession: 60,
        totalMinutesPerWeek: 180,
      },
      {
        level: 'Strong',
        minutesPerSession: 50,
        totalMinutesPerWeek: 150,
      },
      {
        level: 'Very Strong',
        minutesPerSession: 40,
        totalMinutesPerWeek: 120,
      },
      {
        level: 'Elite',
        minutesPerSession: 30,
        totalMinutesPerWeek: 90,
      },
    ],
    summaryContent: [
      {
        minutes: 0,
        riskOfDyingEarly: 'Highest Risk (100% baseline)',
        cognitiveDecline: 'Baseline (0%)',
        brainAgingActive: 'No fitness protection',
        brainAgingSedentary: 'Accelerated aging trajectory',
      },
      {
        minutes: 75,
        riskOfDyingEarly: '90% of early-death risk',
        cognitiveDecline: '~5–10% lower',
        brainAgingActive: 'Slightly younger',
        brainAgingSedentary: 'Slightly older',
      },
      {
        minutes: 150,
        riskOfDyingEarly: '80% of early-death risk',
        cognitiveDecline: '~15–20% lower',
        brainAgingActive: 'Noticeably younger trajectory',
        brainAgingSedentary: 'Noticeably older',
      },
      {
        minutes: 225,
        riskOfDyingEarly: '72% of early-death risk',
        cognitiveDecline: '~20–30% lower',
        brainAgingActive: 'Younger, more stable trajectory',
        brainAgingSedentary: 'Older, faster decline',
      },
      {
        minutes: 300,
        riskOfDyingEarly: '65% of early-death risk',
        cognitiveDecline: '~25–35% lower',
        brainAgingActive: 'Optimized',
        brainAgingSedentary: 'Worst-case brain-age path',
      },
    ],
  },
  navigationItems: {
    aboutProject: 'About Project',
    habits: 'Habits',
    environment: 'Environment',
    results: 'Results',
    aiAssistant: 'AI Assistant',
  },
  subNavigationItems: {
    lifestyle: 'Lifestyle',
    study: 'Study',
    diet: 'Diet',
    workout: 'Workout',
    sleep: 'Sleep',
    supplements: 'Supplements',
  },
  nextBtn: 'Next: ',
  contentsTxt: 'Contents',
};

export default en;
